// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useBindActionsCreator from '../../../hooks/useBindActionsCreator';
import useMergeProps from '../../../hooks/useMergeProps';
import { openKLView } from '../actions/routes';
import KLBanner from '../components/KLBanner';
import { selectKLGlobalStatus } from '../selectors/global';
import { selectIsKLEnabled } from '../selectors/runtime';
import KLBannerSelectors from '../selectors/specifics/KLBannerSelectors';
import { KLGlobalStatuses } from '../types/global';

type KLBannerContainerProps = {
  className?: string;
};

const KLBannerContainer = (ownProps: KLBannerContainerProps) => {
  const isKLEnabled = useSelector(selectIsKLEnabled);
  const globalStatus = useSelector(selectKLGlobalStatus);

  const actions = useMemo(
    () => ({
      onClick: () => openKLView(),
      buttonAction: (e) => {
        if (e) {
          e.stopPropagation();
        }
        return openKLView();
      },
    }),
    [],
  );

  const actionsProps = useBindActionsCreator(actions);

  const backgroundPath = useSelector(KLBannerSelectors.selectBackgroundPath);
  const animatedBackgroundPath = useSelector(KLBannerSelectors.selectAnimatedBackgroundPath);
  const buttonLabel = useSelector(KLBannerSelectors.selectButtonLabel);
  const text = useSelector(KLBannerSelectors.selectText);

  const selectedProps = useMemo(
    () => ({
      backgroundPath,
      animatedBackgroundPath,
      buttonLabel,
      text,
    }),
    [backgroundPath, animatedBackgroundPath, buttonLabel, text],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps, actionsProps });

  return isKLEnabled && globalStatus === KLGlobalStatuses.RUNNING ? <KLBanner {...enhancedProps} /> : null;
};

export default KLBannerContainer;
